import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as MultipliersActions } from "store/ducks/multipliers";

import { Validate, Access } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Points/Multipliers/components";
import { useDefaultDateFormat } from "helpers";

class Create extends Component {
  state = {
    data: {
      description: "",
      multiplier: "",
      start_at: "",
      end_at: "",
      observation: "",
      send_email: false,
      store_channels: [],
      store_channels_all: true,
      store_region_ids: [],
      store_region_ids_all: true,
      extra_data: {
        store_places: Access.lockedStore() ? [Access.lockedStore(true)] : [],
        store_places_all: Access.lockedStore() ? false : true,
        classification_passions: [],
        classification_passions_all: true,
        store_product_types: Access.lockedProductType()
          ? [Access.lockedProductType(true)]
          : [],
        store_product_types_all: Access.lockedProductType() ? false : false,
        store_sections: [],
        store_sections_all: false,
        store_sub_sections: Access.lockedSection()
          ? [Access.lockedSection(true)]
          : [],
        store_sub_sections_all: Access.lockedSection() ? false : false,
        store_groups: [],
        store_sub_groups: [],
        remove_mdh: false,
        add_mdh: false,
        add_store_products: [],
        remove_store_products: [],
        all_products: false,
      },
    },
    errors: {},
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "/points" },
      { name: "Campanha de Pontos", to: "/points/multiplier" },
      { name: "Adicionar Novo", to: "" },
    ],
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      description: {
        required: true,
      },

      multiplier: {
        required: true,
      },

      start_at: {
        required: true,
      },

      end_at: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { createMultiplierRequest } = this.props;


    const formData = {
      points_campaign: {
        description: data.description,
        multiplier: data.multiplier,
        start_at: useDefaultDateFormat(data.start_at),
        end_at: useDefaultDateFormat(data.end_at),
        store_channel_ids: !!data.store_channels_all
          ? []
          : data.store_channels.map((channel) => channel.value),
        store_region_ids: data.store_region !== undefined ? [data.store_region.value] : [],
        extra_data: {
          experience_plan_ids: data.extra_data.experience_plan_ids,
          store_places: data.extra_data.store_places,
          store_places_all: data.extra_data.store_places_all,
          classification_passions: data.extra_data.classification_passions,
          classification_passions_all:
            data.extra_data.classification_passions_all,
          store_product_types: data.extra_data.store_product_types,
          store_product_types_all: data.extra_data.store_product_types_all,
          store_sections: data.extra_data.store_sections,
          store_sections_all: data.extra_data.store_sections_all,
          store_sub_sections: data.extra_data.store_sub_sections,
          store_sub_sections_all: data.extra_data.store_sub_sections_all,
          store_groups: data.extra_data.store_groups,
          store_sub_groups: data.extra_data.store_sub_groups,
          remove_mdh: data.extra_data.remove_mdh,
          add_mdh: data.extra_data.add_mdh,
          add_store_products: data.extra_data.add_store_products,
          remove_store_products: data.extra_data.remove_store_products,
          send_email: data.extra_data.send_email,
          all_products: data.extra_data.all_products,
        },
      },
    };

    createMultiplierRequest(formData);
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={create.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  create: state.multipliers.create,
});

const mapActions = (dispatch) =>
  bindActionCreators(MultipliersActions, dispatch);

export default connect(mapState, mapActions)(Create);
